var ADD_DELTA_TYPE = 'ADD_DELTA_TYPE';
var REMOVE_DELTA_TYPE = 'REMOVE_DELTA_TYPE';
var UPDATE_DELTA_TYPE = 'UPDATE_DELTA_TYPE';
export { ADD_DELTA_TYPE };
export { REMOVE_DELTA_TYPE };
export { UPDATE_DELTA_TYPE };